<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef> No. </th>
    <td mat-cell *matCellDef="let tenant"> {{tenant.position}} </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Name </th>
    <td mat-cell *matCellDef="let tenant"> {{tenant.name}} </td>
  </ng-container>
  
  <!-- Logo Column -->
  <ng-container matColumnDef="logo">
    <th mat-header-cell *matHeaderCellDef> Logo </th>
    <td mat-cell *matCellDef="let tenant"> <img src="{{tenant.logo}}" width="50px" height="auto"> </td>
  </ng-container>

  <!-- Percent Column -->
  <ng-container matColumnDef="percent">
    <th mat-header-cell *matHeaderCellDef> Percent </th>
    <td mat-cell *matCellDef="let tenant"> {{tenant.percent | percent}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

